<template>
  <billing-report-panel
    report-key="glosses-insurance"
    route="/reports/billing-glosses-insurance"
    file-name="glosas-por-convenio.xlsx"
    :columns="columns"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Convênio e plano',
        'Lotes',
        'Guias glosadas',
        'Faturado',
        'Glosado',
        'Glosa %',
        'Recursado',
        'Recuperado',
        'Perda assumida',
      ],
    };
  },
};
</script>
